import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Person, { propTypes as personPropTypes } from '../../../components/Person';

const Container = styled.div`
  margin-top: -25px;
`;

const renderPerson = (item) => <Person {...item} />;

const Page = ({ pageData }) => (
  <Container>
    {pageData.contacts.map(renderPerson)}
  </Container>
);

Page.propTypes = {
  pageData: PropTypes.shape({
    title: PropTypes.string.isRequired,
    persons: PropTypes.arrayOf(PropTypes.shape(personPropTypes)),
  }).isRequired,
};

export default Page;
